const doc = [({"da":({"js":({"admin":({"photo_sessions":({"show":({"index":({"photo_session_for":"Fotosession for: %{name}"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;